import { useQuery } from '@apollo/client'
import { useActiveChannelInstance } from '@chain-zen/chat'
import React from 'react'

import { GET_POST_BY_ID } from '../../../data/queries/offer'
import type { IPublicPostData } from '../../../types/post'
import { PostInfo } from './post-info'
import { getChatPostMetadata, syncPostDataInPostOfferChatMetadata } from './utils'

interface CarrierViewProps {
  postID: string
}

export const CarrierView = ({ postID }: CarrierViewProps) => {
  const channel = useActiveChannelInstance()

  const { loading, data } = useQuery<{ getPostByID: IPublicPostData }>(GET_POST_BY_ID, {
    fetchPolicy: 'network-only',
    onCompleted: async ({ getPostByID: post }) => {
      if (post && channel) {
        const chatPostMetadata = getChatPostMetadata(post)
        await syncPostDataInPostOfferChatMetadata({
          chatPostMetadata,
          postChannel: channel
        })
      }
    },
    skip: !postID,
    variables: { id: postID }
  })

  if (loading) return null

  return !!data?.getPostByID && <PostInfo post={data?.getPostByID} />
}
